// Fixed day-cell dimensions (the Figma 58x44 pill). The grid caps each column
// at CALENDAR_DAY_WIDTH and centers the block, so the cells keep these
// dimensions on wide panes and only compress when too narrow to fit seven.
export const CALENDAR_DAY_WIDTH = 58;
export const CALENDAR_DAY_HEIGHT = 44;
